<template>
  <v-dialog v-model="dialog" max-width="1500" style="overflow: hidden !important;" v-if="selectedProject">
    <v-card>
      <v-card-title>
        {{selectedProject.name}} Projesine Ait Siparişler
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container" v-if="selectedProject">
            <ProjectOrderResults :selectedProjectCode="selectedProject.code"></ProjectOrderResults>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ProjectOrderResults from "@/components/project/results/ProjectOrderResults.vue";
export default {
  name: "ProjectOrdersDialog",
  components: {
    ProjectOrderResults,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    selectedProject: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    closeDialog(){
      this.dialog = false;
    },
  },
  watch: {
    dialog(newVal) {
      this.$emit("dialogChange", newVal)
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    },
  }
}
</script>

<style scoped>

</style>